/* MARQUE v42 Saved pieces — local-only favorite products. No tracking calls. */
(() => {
  'use strict';
  const KEY = 'marque-saved-pieces-v1';
  const root = document.querySelector('[data-marque-saved-root]');
  if (!root || window.marqueSavedInitialized) return;
  window.marqueSavedInitialized = true;

  const drawer = root.querySelector('[data-marque-saved-drawer]');
  const launcher = root.querySelector('[data-marque-saved-open]');
  const list = root.querySelector('[data-marque-saved-items]');
  const empty = root.querySelector('[data-marque-saved-empty]');
  const clear = root.querySelector('[data-marque-saved-clear]');
  const live = root.querySelector('[data-marque-saved-status]');
  let lastFocus = null;
  let items = [];

  function allowedLink(raw) {
    if (!raw || typeof raw !== 'string') return false;
    try {
      const url = new URL(raw, window.location.origin);
      return url.origin === window.location.origin &&
        /\/products\/[a-z0-9-]+\/?$/i.test(url.pathname);
    } catch { return false; }
  }
  function allowedImage(raw) {
    if (!raw || typeof raw !== 'string') return false;
    try {
      const url = new URL(raw, window.location.origin);
      return url.protocol === 'https:' &&
        (url.hostname === window.location.hostname || url.hostname === 'cdn.shopify.com' || url.hostname.endsWith('.shopifycdn.net'));
    } catch { return false; }
  }
  function sanitize(raw) {
    if (!raw || !/^\d+$/.test(String(raw.id || '')) || !allowedLink(raw.url)) return null;
    return {
      id: String(raw.id),
      url: String(raw.url),
      name: String(raw.name || 'MARQUE piece').slice(0, 115),
      price: String(raw.price || '').slice(0, 45),
      image: allowedImage(raw.image) ? raw.image : ''
    };
  }
  function read() {
    try {
      const arr = JSON.parse(window.localStorage.getItem(KEY) || '[]');
      return Array.isArray(arr) ? arr.map(sanitize).filter(Boolean).slice(0, 35) : [];
    } catch { return []; }
  }
  function persist() {
    try { window.localStorage.setItem(KEY, JSON.stringify(items)); }
    catch { /* Browsers may block storage. Favorites still work until reload. */ }
  }
  function iconButtonText(button, saved) {
    const name = button.dataset.productTitle || 'product';
    button.setAttribute('aria-pressed', String(saved));
    button.setAttribute('aria-label', saved ? 'Remove ' + name + ' from saved pieces' : 'Save ' + name + ' to saved pieces');
    button.title = saved ? 'Remove from saved pieces' : 'Save for later';
    const word = button.querySelector('.marque-save-button__word');
    if (word && word.textContent !== (saved ? 'Saved' : 'Save')) {
      word.textContent = saved ? 'Saved' : 'Save';
    }
  }
  function renderList() {
    list.replaceChildren();
    items.forEach((item) => {
      const li = document.createElement('li');
      li.className = 'marque-saved-item';
      const a = document.createElement('a');
      a.className = 'marque-saved-item__link';
      a.href = item.url;
      const image = document.createElement('span');
      image.className = 'marque-saved-item__image';
      if (item.image) {
        const img = document.createElement('img');
        img.src = item.image; img.alt = ''; img.width = 160; img.height = 200;
        img.loading = 'lazy'; img.decoding = 'async';
        image.appendChild(img);
      }
      const titleBox = document.createElement('span');
      const name = document.createElement('span');
      name.className = 'marque-saved-item__name';
      name.textContent = item.name;
      const price = document.createElement('span');
      price.className = 'marque-saved-item__price';
      price.textContent = item.price;
      titleBox.append(name, price);
      a.append(image, titleBox);
      const remove = document.createElement('button');
      remove.type = 'button'; remove.className = 'marque-saved-item__remove';
      remove.dataset.marqueSavedRemove = item.id;
      remove.textContent = '×';
      remove.setAttribute('aria-label', 'Remove ' + item.name + ' from saved pieces');
      li.append(a, remove);
      list.appendChild(li);
    });
    empty.hidden = items.length !== 0;
    clear.hidden = items.length === 0;
  }
  function update() {
    launcher.hidden = items.length === 0;
    launcher.setAttribute('aria-label', 'Open ' + items.length + ' saved pieces');
    root.querySelectorAll('[data-marque-saved-count]').forEach(el => el.textContent = String(items.length));
    document.querySelectorAll('[data-marque-save]').forEach(btn => {
      iconButtonText(btn, items.some(item => item.id === btn.dataset.productId));
    });
    renderList();
  }
  function closeDrawer() {
    if (drawer.hidden) return;
    drawer.hidden = true;
    document.documentElement.classList.remove('marque-saved-open');
    if (lastFocus?.isConnected && !lastFocus.hidden) lastFocus.focus();
    else if (!launcher.hidden) launcher.focus();
    else document.querySelector('[data-marque-save]')?.focus();
  }
  function openDrawer() {
    if (!drawer.hidden) return;
    lastFocus = document.activeElement;
    drawer.hidden = false;
    document.documentElement.classList.add('marque-saved-open');
    drawer.querySelector('[data-marque-saved-close].marque-saved-close')?.focus();
  }
  items = read();
  update();

  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    const btn = event.target.closest('[data-marque-save]');
    if (btn) {
      event.preventDefault();
      event.stopPropagation();
      const id = btn.dataset.productId;
      const idx = items.findIndex(item => item.id === id);
      if (idx !== -1) {
        const removed = items.splice(idx, 1)[0];
        live.textContent = removed.name + ' removed from saved pieces.';
      } else {
        const record = sanitize({
          id, name: btn.dataset.productTitle, url: btn.dataset.productUrl,
          price: btn.dataset.productPrice, image: btn.dataset.productImage
        });
        if (!record) return;
        items.unshift(record);
        items = items.slice(0, 35);
        live.textContent = record.name + ' added to saved pieces.';
      }
      persist(); update();
      return;
    }
    const share = event.target.closest('[data-marque-share]');
    if (share) {
      event.preventDefault();
      event.stopPropagation();
      try {
        const raw = share.dataset.url;
        if (!allowedLink(raw)) return;
        const url = new URL(raw, window.location.origin).href;
        const title = share.dataset.title || 'MARQUE';
        if (navigator.share) {
          navigator.share({ title, url }).then(() => {
            live.textContent = 'Ready to share.';
          }).catch(err => {
            if (err?.name !== 'AbortError') live.textContent = 'Sharing was not completed.';
          });
        } else if (navigator.clipboard?.writeText) {
          navigator.clipboard.writeText(url).then(() => {
            live.textContent = 'Product link copied.';
            share.title = 'Link copied';
          }).catch(() => {
            window.prompt('Copy the product link:', url);
          });
        } else {
          window.prompt('Copy the product link:', url);
        }
      } catch { live.textContent = 'Sharing was not completed.'; }
      return;
    }
    if (event.target.closest('[data-marque-saved-open]')) { openDrawer(); return; }
    if (event.target.closest('[data-marque-saved-close]')) { closeDrawer(); return; }
    const remove = event.target.closest('[data-marque-saved-remove]');
    if (remove) {
      items = items.filter(item => item.id !== remove.dataset.marqueSavedRemove);
      persist(); update();
      live.textContent = 'Piece removed.';
      if (!items.length) drawer.querySelector('.marque-saved-close')?.focus();
      return;
    }
    if (event.target.closest('[data-marque-saved-clear]')) {
      items = []; persist(); update(); live.textContent = 'Saved pieces cleared.';
    }
  });

  document.addEventListener('keydown', event => {
    if (drawer.hidden) return;
    if (event.key === 'Escape') { event.preventDefault(); closeDrawer(); return; }
    if (event.key !== 'Tab') return;
    const panel = drawer.querySelector('.marque-saved-panel');
    const elements = Array.from(panel.querySelectorAll('button:not([disabled]),a[href]')).filter(el => el.getClientRects().length);
    if (!elements.length) return;
    const first = elements[0], last = elements[elements.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  });

  // Shopify's collection facets can replace product cards without reloading
  // the page. Sync saved states on newly injected cards.
  const main = document.getElementById('MainContent');
  if (main && 'MutationObserver' in window) {
    let scheduled = false;
    const observer = new MutationObserver((mutations) => {
      const hasNewCards = mutations.some(mutation =>
        Array.from(mutation.addedNodes).some(node =>
          node.nodeType === 1 &&
          (node.matches?.('[data-marque-save]') || node.querySelector?.('[data-marque-save]'))
        )
      );
      if (!hasNewCards || scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(() => {
        scheduled = false;
        update();
      });
    });
    observer.observe(main, { childList: true, subtree: true });
  }

  document.addEventListener('shopify:section:load', update);
  window.addEventListener('storage', (e) => { if (e.key === KEY) { items = read(); update(); } });
})();
